import { i18n } from 'fishx';
import get from 'lodash/get';
import { getRequestData, getTTRequestData, successAlert, failAlert } from '@/utils';
import { qryTaskList, workOrderComplete, leadSaveCustId } from '@/pages/LeadsManagement/services';
import { qryCustExist } from '@/pages/LeadsManagement/services/bssIndex';

export default {
  namespace: 'leadsManagement',
  state: {
    total: 10,
    searchTableData: [],
    serviceTypelist: [],
  },
  effects: {
    *qryTaskList({ payload }, { call, put }) {
      const response = yield call(qryTaskList, payload);
      const result = getTTRequestData(response);
      const pageIndex = get(result, 'pageNum') || get(payload, 'pageNum');
      if (pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(result, 'count') || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: {
          searchTableData: get(result, 'workOrderList') || [],
        },
      });
      return result;
    },
    *workOrderComplete({ payload }, { call }) {
      const params = {
        channel: 'DSCM',
        ...payload,
      };
      const response = yield call(workOrderComplete, params);
      const { returnCode, returnMsg } = getRequestData(response) || {};
      if (returnCode === '0' && returnMsg === 'Success') {
        successAlert({
          content: i18n('COMMON_ALERT_SUCCESS'),
        });
        return true;
      }
      failAlert({
        content: returnMsg,
      });
      return false;
    },
    *qryCustExist({ payload }, { call }) {
      const response = yield call(qryCustExist, payload);
      const { data } = response || {};
      const { custId } = data;
      if (custId) {
        return custId;
      }
      return false;
    },
    *leadSaveCustId({ payload }, { call }) {
      const response = yield call(leadSaveCustId, payload);
      const result = getTTRequestData(response);
      const { resultCode, resultMsg } = result;
      if (resultCode === '0') {
        return true;
      }
      failAlert({
        content: resultMsg,
      });
      return false;
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
